import { useState } from 'react'
import { useInstance } from '@10000/react'
import { InputScreen, useBackground, useShell, useStack } from '../layout'
import { Body, Box } from '../widgets'
import { Password, Submit, Text } from '../forms'
import { authenticate, forgotPassword } from './request.js'
import { AccountVerification, SignUp } from './'
import { PasswordSetUp } from '../onboarding/index.js'

export const ForgotPassword = ({ active }) => {
  const { push, replaceStack } = useStack()
  const { setInstance } = useInstance()

  const [codeSent, setCodeSent] = useState(false)
  const [message, setMessage] = useState('')
  const [challenge, setChallenge] = useState('')

  useBackground().set({ active, background: 2, fade: true })
  useShell({ active, mode: 'navigate' })

  const authenticateUser = (username, password) => authenticate(username, password).then(res => {
    const { success, challenge, user } = res
    if(success) {
      setInstance({ id: user.tenantId, region: user.region })
    } else if (challenge) {
      if(challenge.type === 'NEW_PASSWORD_REQUIRED') {
        replaceStack(PasswordSetUp, { props: { challenge: challenge.type, session: challenge.session, username: challenge.username } })
      }
    }
  })

  const sendRequest = async (username) => {
    const email = username || document.getElementById('username').value

    return forgotPassword(email).then(({ success, message, challenge }) => {
      if(success){
        setChallenge(challenge)
        setMessage("We've sent you an email")

        if(challenge === 'CONFIRMATION_CODE'){
          return push(AccountVerification, { props: { email } })
        }

        setCodeSent(true)
      } else {
        setMessage("An error occurred")
        throw new Error(message)
      }
    })
  }

  const submit = ({ username, code, password }) => {
    if(codeSent && password) {
      if(challenge === 'CODE_AND_PASSWORD') {
        return forgotPassword(username, code, password).then(() => authenticateUser(username, password))
      } else if(challenge === 'TEMPORARY_PASSWORD') {
        return authenticateUser(username, password)
      }
    } else if(!codeSent) {
      return sendRequest(username)
    }
  }

  return <InputScreen centered onSubmit={submit} title="Forgot password">
    <Box fullWidth gap={16} column alignItems="center">
      {message && <Body align="center">{message}</Body>}
      {codeSent && <Box cursor="pointer" onClick={() => sendRequest()}>
        <Body underline bold color="white" align="center">
          Didn&apos;t receive an email? Click to get a new one
        </Body>
      </Box>}

      <Text
        id="username"
        title="Email"
        type="email"
        name="username"
        required
      />
      {codeSent && <>
        {challenge === 'CODE_AND_PASSWORD' && <>
          <Text
            name="code"
            title="Confirmation code"
            required
          />
        </>}
        <Password
          useConfirmedPassword={challenge === 'CODE_AND_PASSWORD'}
          showPasswordRequirements
        />
      </>}
    </Box>

    <Box className="fit-button-to-container" fullWidth>
      <Submit fullWidth>Submit</Submit>
    </Box>

    <Box gap={4} pb={32} alignItems="center">
      <Body>
        New to Shivoo?
      </Body>
      <a onClick={() => push(SignUp)}>Sign-up</a>
    </Box>
  </InputScreen>
}